import { ValidatorFn, AbstractControl, FormGroup, FormControl, FormArray } from "@angular/forms";
import { IGridDefaultOptions } from "../models/custom-models";

export function fixLengthValidation(length: number): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      let allow: boolean;
      if(control.value) {
          length === control.value.length ? allow = true : allow = false;
      }
      return allow ? null : {'fixLength': {actualLength: control.value && control.value.length, requiredLength: length}};
    };
} 

export function emailValidation(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        var pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi);
        const validate: boolean = control.value.length ? true : false;
        if (validate) {
            return pattern.test(control.value) ? null : {'email': false};
        }
        return null;
    };
}

export function twoDecimalPlacesValidation(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        var pattern = new RegExp(/^\s*-?\d+(\.\d{1,2})?\s*$/);
        const validate: boolean = control.value ? true : false;
        if (validate) {
            return pattern.test(control.value) ? null : {'twoDeciamls': false};
        }
        return null;
    };
}

export function wholeNumberValidation(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        var pattern = new RegExp(/^\d+$/);
        const validate: boolean = control.value ? true : false;
        if (validate) {
            return pattern.test(control.value) ? null : {'wholeNumber': false};
        }
        return null;
    };
}

export function generateURLstring(...args): string {
    var url: string = '';
    for (let i = 0; i < args.length; i++) {
        url = url + args[i].toString() + (i == args.length -1 ? '' : '/' );
    }
    return url;
}

export function validateAllFormFields(formGroup: FormGroup) {     
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
            validateAllFormFields(control);
        } else if (control instanceof FormArray) {
            for (var i: number = 0; control && i < control.controls.length; ++i) {
                validateAllFormFields(<FormGroup>control.controls[i]);
            }            
        }
    });
}

export function generateGridId(arr: any[], idParamName: string) {
    var id = 0;
    arr = arr || [];
    for (var i: number = 0; i < arr.length; ++i) {
        id = arr[i][idParamName] <= id ? arr[i][idParamName] - 1 : id;
    }
    return id;
}

export function checkCodeInGrid(arr: any[], checkParamName: string, idParamName: string, id: number): ValidatorFn {
    var arr = arr || [];
    return (control: AbstractControl): {[key: string]: any} | null => {
        var val = control.value || '';
        if (arr.length) {
            var obj: any = arr.find((item: any) => {return item[checkParamName].toLowerCase() == val.toLowerCase() && item[idParamName] != id});
            return obj ? { noneUniqueCode: true } : null;  
        }                    
        return null;
    };
}

export function passwordMatchValidation(passwordControlName: string, confirmPassControlName: string): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        let password = control.get(passwordControlName).value;
        let confirmPassword = control.get(confirmPassControlName).value;
        if(password !== confirmPassword) {
            return { passwordsDontMutch: true };
        }
        return null;
    };
} 

export function getErrorMessage(errorMessage?: string) {
    swal('Error', errorMessage || 'Something went wrong', 'error');
}

export function getWarningrMessage(warningMessage: string) {
    swal('Warning', warningMessage, 'warning');
}

export function compareTwoArrays(arr1: number[], arr2: number[]): boolean {

    if (arr1 && arr2 && arr1.length == 0 && arr2.length == 0)
        return true;

    if (arr1 && arr2 && arr1.length != arr2.length)
        return false;

    if (!!arr1 && !arr2 || !!arr2 && !arr1) {
        return false;
    }

    for (var i: number = 0; arr1 && i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) == -1) { 
            return false;   
        }           
    }       
    return true;
}

export function getGridDefaultOptions(): IGridDefaultOptions { 
    return {
        resizable: true,
        selectable: 'row',
        reorderable: true,
        scrollable: 'none',
        pageSize: 5,
        pageable: {
            buttonCount: 5,
            info: true,
            type: 'numeric',
            pageSizes: true,
            previousNext: true
        },
        sortable: {mode: 'single'},
        groupable: false,
        columnMenu: { filter: true },
        state: {
            skip: 0,
            take: 10
        }
    }
}

export function isNull(value: any): boolean {
    return value == null || value == undefined;
}